import gql from "graphql-tag";

const gqlQuery = gql`
  query Asset($assetId: ID, $customerId: ID) {
    asset(assetId: $assetId, customerId: $customerId) {
      id
      codename
      format
      path
      description
      customerId
      hasGraphicsets
      categoryIds
      categories {
        id
        name
        codename
      }
      sizePx {
        x
        y
      }
    }
  }
`;

export default (assetId, customerId, hasAdminPrivileges) => ({
  query: gqlQuery,
  skip: !assetId || (!customerId && !hasAdminPrivileges),
  variables: { assetId, customerId },
});
